import React, { useRef } from 'react';

import { Button } from 'antd';

import NewForm from '../../components/MatrizFilial/NewForm';
import Table from '../../components/MatrizFilial/Table';
import Page from '../../layout/Page';
import { ButtonContainer } from './styles';

function MatrizFilial() {
  const newRef = useRef();
  const tableRef = useRef();

  return (
    <Page title="Matriz e Filial" selectedKey="8">
      <ButtonContainer>
        <Button type="primary" onClick={() => newRef.current.open()}>
          Cadastrar
        </Button>
      </ButtonContainer>
      <NewForm ref={newRef} onSuccess={() => tableRef.current?.reload()} />
      <Table ref={tableRef} />
    </Page>
  );
}

export default MatrizFilial;
